import { render, staticRenderFns } from "./serial-rejection.vue?vue&type=template&id=2f08c85c"
import script from "./serial-rejection.vue?vue&type=script&lang=js"
export * from "./serial-rejection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f08c85c')) {
      api.createRecord('2f08c85c', component.options)
    } else {
      api.reload('2f08c85c', component.options)
    }
    module.hot.accept("./serial-rejection.vue?vue&type=template&id=2f08c85c", function () {
      api.rerender('2f08c85c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/manager-form/iframe-page/components/form-b/serial-rejection.vue"
export default component.exports